/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { LoggerService } from 'src/app/services/logger.service';
import { StudyService } from 'src/app/services/study.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.page.html',
  styleUrls: ['./calendar.page.scss']
})
export class CalendarPage implements OnInit {
  months: any = [];
  weekdaysShort: any = moment.weekdaysShort();

  constructor(
    private modalCtrl: ModalController,
    private logger: LoggerService,
    private study: StudyService
  ) {}

  getData() {
    const studyStart = this.study.getStartMoment();
    const studyStop = this.study.getStopMoment();
    const iDay = studyStart.clone();
    let done = false;

    const getDays = (iDay, targetMonth) => {
      const days = [];
      const myWeek = iDay.clone();

      while (iDay.isSame(myWeek, 'week')) {
        const iYmd = iDay.format('YYYYMMDD');
        // let phase               = this.study.getPhaseByYMD(iYmd);
        // let ts                  = tripSurveys.filter(s => s.ymd === iYmd && (s.personId === person.idx || (s['_CB_householders_' + person.idx] === 1 && s.complete === 1)));
        // ts                      = phase && phase.proxying != 1 ? ts.filter(s => s.personId === person.idx) : ts;
        // let ds                  = dailySurveys.filter(s => s.surveyDate == iYmd && s.personId === person.idx);
        // let pp                  = getProxyPrompts(person, iDay, isLd);
        // let surveyCount         = ts.length + ds.length;
        // let incompleteCount     = ts.filter(s => s.complete === 0).length + ds.filter(s => s.complete === 0).length;
        // person.incompleteCount += iDay.isSame(targetMonth, 'month') ? incompleteCount : 0; // only count if in target month - otherwise you'll double count

        days.push({
          // moment: iDay.clone(),
          dayNum: iDay.date(),
          // ymd: iYmd,
          // display: iDay.format('lll'),
          // isCurrentMonth: iDay.isSame(targetMonth, 'month'),
          // isToday: iDay.isSame(moment(), 'day'),
          isInStudy: iDay.isSameOrAfter(studyStart, 'day') && iDay.isSameOrBefore(studyStop, 'day'),
          isOutsideMonth: !iDay.isSame(targetMonth, 'month')
          // isAfterToday: iDay.isAfter(moment(), 'day'),
          // tripSurveys: ts,
          // dailySurveys: ds,
          // proxyPrompts: pp,
          // surveyCount: surveyCount,
          // incompleteCount: incompleteCount,
          // phase: phase
        });
        iDay.add(1, 'day');
      }
      return days;
    };

    const getWeeks = (iDay) => {
      const weeks = [];
      const myMonth = iDay.clone();
      const maxDay = studyStop.day(6);

      if (iDay.month() === studyStart.month()) {
        iDay.day(0); // for the first month, ignore weeks prior to start month
      } else {
        iDay.date(1).day(0); // for months 2-n, start on sunday of the first week of month
      }

      while (iDay.isSameOrBefore(myMonth, 'month')) {
        if (iDay.isAfter(maxDay)) {
          done = true;
          break;
        }
        weeks.push({ weekNum: iDay.week(), days: getDays(iDay, myMonth) });
      }
      return weeks;
    };

    const getMonths = () => {
      const months = [];
      while (iDay.isSameOrBefore(studyStop, 'month') && done === false) {
        months.push({ text: iDay.format('MMMM YYYY'), ym: iDay.format('YYYYMM'), weeks: getWeeks(iDay) });
      }
      return months;
    };

    return getMonths();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.months = this.getData();
  }
}
